export const orderPanelPage = {
  title: "Painel de pedidos",
  ready: "Pronto"
};
